
export default class centraFilterButton {
    constructor(el){
        this.el = el;
        this.initEvents();
    }

    initEvents() {
        this.el.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleChange();
        });
    }

    handleChange(e) {       
        window.location.reload();
    }
}